import { ReactElement, ReactNode } from 'react';

import { Box, Grid } from '@mui/material';
import Icon from '@apigrowfinance/pbolt-icon';
import TextDisplay from '@apigrowfinance/pbolt-text-display';

interface ContactDetailsProp {
    icon?: ReactElement;
    textBaseTestId: string;
    textLabel: ReactNode;
    textValue: number | string | ReactNode;
    isLoading: boolean;
}
const ContactDetails = ({
    icon,
    textBaseTestId,
    textLabel,
    textValue,
    isLoading,
}: ContactDetailsProp) => {
    return (
        <Grid item xs={12} sm={2}>
            <Box
                sx={{
                    display: 'flex',
                    mr: 2,
                    alignItems: 'center',
                }}>
                {icon && (
                    <Icon data-testid="avatar-icon" isLoading={isLoading}>
                        {icon}
                    </Icon>
                )}
                <Box sx={{ ml: 2, flexGrow: 1 }}>
                    <TextDisplay
                        testId={textBaseTestId}
                        label={textLabel}
                        value={textValue}
                        isLoading={isLoading}
                    />
                </Box>
            </Box>
        </Grid>
    );
};

export default ContactDetails;
